import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export let isBrowser = true;
export let document: Document;
export let window: Window | any;

/** @dynamic */
@NgModule({})
export class WUniversalModule {
  static init = new BehaviorSubject(false);
  constructor(@Inject(PLATFORM_ID) platformId: string, @Inject(DOCUMENT) private doc: Document) {
    isBrowser = isPlatformBrowser(platformId);
    document = doc;
    window = doc.defaultView;
    
    /** w-angular disables loading of compatibility css */
    window.noUlfcompatibility = true;

    WUniversalModule.init.next(true);
  }
}
